var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlerta24X24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0981 2.12934C11.6935 2.01027 12.3065 2.01027 12.9019 2.12934C14.2248 2.39392 15.3648 3.22606 16.02 4.40539L22.2059 15.54C22.5627 16.1824 22.75 16.9051 22.75 17.6399C22.75 20.0279 20.8141 21.9638 18.4261 21.9638H5.57391C3.18588 21.9638 1.25 20.0279 1.25 17.6399C1.25 16.9051 1.43727 16.1824 1.79413 15.54L7.98005 4.40539C8.63523 3.22606 9.77522 2.39392 11.0981 2.12934ZM12.6077 3.60021C12.2065 3.51998 11.7935 3.51998 11.3923 3.60021C10.5009 3.77849 9.73276 4.3392 9.29128 5.13386L3.10537 16.2685C2.8723 16.688 2.75 17.16 2.75 17.6399C2.75 19.1995 4.01431 20.4638 5.57391 20.4638H18.4261C19.9857 20.4638 21.25 19.1995 21.25 17.6399C21.25 17.16 21.1277 16.688 20.8946 16.2685L14.7087 5.13386C14.2672 4.3392 13.4991 3.77849 12.6077 3.60021Z",
    fill: "#FF655A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13.4638C11.5858 13.4638 11.25 13.128 11.25 12.7138V8.71382C11.25 8.29961 11.5858 7.96382 12 7.96382C12.4142 7.96382 12.75 8.29961 12.75 8.71382V12.7138C12.75 13.128 12.4142 13.4638 12 13.4638Z",
    fill: "#FF655A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16.9638C12.4142 16.9638 12.75 16.628 12.75 16.2138V15.7138C12.75 15.2996 12.4142 14.9638 12 14.9638C11.5858 14.9638 11.25 15.2996 11.25 15.7138V16.2138C11.25 16.628 11.5858 16.9638 12 16.9638Z",
    fill: "#FF655A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerta24X24);
export default __webpack_public_path__ + "static/media/ALERTA_24X24.cc1be84e733fb4f38ab1c602726fdcee.svg";
export { ForwardRef as ReactComponent };